import { useRef, useState } from 'react'
import { useLocation, useParams } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { useRequest } from './UseRequest'
import { setNotification } from '../redux/notificationSlice'

// Only these routes' `:id` is a customer id. Other `/:module_name/:id` routes
// (e.g. loan, lead) use their own record's id, not a customer id.
const CUSTOMER_SCOPED_MODULES = ['customer', 'manual_verification', 'payment_schedule']

export function useLeadsWithLoans() {
  const dispatch = useDispatch()
  const requests = useRequest()
  const params = useParams()
  const location = useLocation()
  const [leadData, setLeadData] = useState(null)
  const requestedCustomerId = useRef(null)

  // Callers stay mounted across customer pages, so drop the previous customer's leads before
  // loading, and ignore a response for a customer the agent has already navigated away from.
  const getLeadsWithLoans = async () => {
    const currentModule = location.pathname.split('/')[1]
    const customerId = CUSTOMER_SCOPED_MODULES.includes(currentModule) ? params.id : null
    if (requestedCustomerId.current !== customerId) setLeadData(null)
    requestedCustomerId.current = customerId
    if (!customerId) { return }
    try {
      requests.setEndpoint(`${process.env.REACT_APP_API_DOMAIN}/customer/${customerId}/leads_with_loan_ids`)
      const response = await requests.get()
      if (requestedCustomerId.current !== customerId) { return }
      setLeadData((response.data ?? []).map((lead) => ({
        value: lead.id,
        label: lead.guid,
        loans: lead.loan_id ? [{ value: lead.loan_id, label: lead.loan_guid }] : [],
      })))
    } catch (error) {
      if (requestedCustomerId.current !== customerId) { return }
      dispatch(setNotification({ type: 'error', body: error.response?.data?.message }))
    }
  }

  return { leadData, getLeadsWithLoans }
}
